import {
  DEFAULT_GCC_COUNTRY_CODE,
  detectCountryFromE164,
  e164ToLocalDigits,
  formatLocalPhoneInput,
  toE164Phone,
} from '@/lib/phone'
import { SALON_DESK_MASTERS } from '@/lib/salonDeskConfig'

export function emptyCustomerForm() {
  return {
    name: '',
    phoneCountry: DEFAULT_GCC_COUNTRY_CODE,
    phoneLocal: '',
    gender: 'unknown',
    email: '',
    dob: '',
    allergies: '',
    notes: '',
    preferred_stylist_id: '',
    marketing_consent: false,
    blacklist: false,
    hair_type: '',
    hair_colour: '',
    skin_type: '',
    special_instructions: '',
  }
}

/**
 * @param {import('@/types/api').Customer} customer
 */
export function customerToForm(customer) {
  const phoneCountry = detectCountryFromE164(customer.phone ?? '')
  return {
    name: customer.name ?? '',
    phoneCountry,
    phoneLocal: formatLocalPhoneInput(
      e164ToLocalDigits(customer.phone ?? '', phoneCountry),
      phoneCountry,
    ),
    gender: customer.gender ?? 'unknown',
    email: customer.email ?? '',
    dob: customer.dob ?? '',
    allergies: customer.allergies ?? '',
    notes: customer.notes ?? '',
    preferred_stylist_id: customer.preferred_stylist_id ?? '',
    marketing_consent: Boolean(customer.marketing_consent),
    blacklist: Boolean(customer.blacklist),
    hair_type: customer.hair_type ?? '',
    hair_colour: customer.hair_colour ?? '',
    skin_type: customer.skin_type ?? '',
    special_instructions: customer.special_instructions ?? '',
  }
}

/**
 * @param {ReturnType<typeof emptyCustomerForm>} form
 * @param {{ includeBlacklist?: boolean }} [options]
 */
export function customerFormToPayload(form, options = {}) {
  const phone = toE164Phone(form.phoneLocal, form.phoneCountry)
  /** @type {Record<string, unknown>} */
  const payload = {
    name: form.name,
    phone,
    gender: form.gender,
    email: form.email || null,
    dob: form.dob || null,
    allergies: form.allergies || null,
    notes: form.notes || null,
    preferred_stylist_id: form.preferred_stylist_id
      ? Number(form.preferred_stylist_id)
      : null,
    marketing_consent: form.marketing_consent,
  }

  if (SALON_DESK_MASTERS.showBeautyProfile) {
    payload.hair_type = form.hair_type || null
    payload.hair_colour = form.hair_colour || null
    payload.skin_type = form.skin_type || null
    payload.special_instructions = form.special_instructions || null
  }

  if (options.includeBlacklist && SALON_DESK_MASTERS.showCustomerBlacklist) {
    payload.blacklist = form.blacklist
  }

  return payload
}

/**
 * @param {unknown} error
 * @param {string} field
 */
export function getCustomerFieldError(error, field) {
  return error?.response?.data?.errors?.[field]?.[0] ?? null
}
